import type { TextField } from "@/types/template";
import { focusNextTabbable } from "@/components/filler/fields/fieldUtils";

interface Props {
  field: TextField;
  value: string;
  onChange: (value: unknown) => void;
  interpolate: (text: string) => string;
  onBlur?: () => void;
}

function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) {
  if (e.key === "Tab" && !e.shiftKey) {
    e.preventDefault();
    focusNextTabbable(e.currentTarget);
  }
}

export function TextInput({ field, interpolate, onBlur, onChange, value }: Readonly<Props>) {
  const displayDefault = field.defaultValue ? interpolate(field.defaultValue) : "";
  const current = value || displayDefault;

  return field.multiline ? (
    <textarea
      value={current}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      onBlur={onBlur}
      onKeyDown={handleKeyDown}
      rows={4}
    />
  ) : (
    <input
      type="text"
      value={current}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      onBlur={onBlur}
      onKeyDown={handleKeyDown}
    />
  );
}
